<template>
  <div :class="style" @click.stop.prevent="showPopup">
    <div class="pointer" @click.stop.prevent="showPopup">
      <CaretComponent :open="show_popup" class="caret-position-default" variant="red" />
      <img :src="imageSrc" :height="image.height" :width="image.width" :class="imageStyle" />
    </div>
    <div v-show="show_popup" class="popup-container">
      <YummiExtraPopupComponent :popup_data="popup_data" @close="closePopup" />
    </div>
    <BGClickCatcherComponent v-show="show_popup" @click.stop.prevent="showPopup" />
  </div>
</template>

<script>
import YummiExtraPopupComponent from "@/components/YummiExtraPopupComponent.vue";
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent.vue";
import CaretComponent from "@/components/CaretComponent.vue";
export default {
  components: {
    YummiExtraPopupComponent,
    BGClickCatcherComponent,
    CaretComponent
  },
  props: {
    image: Object,
    popup_data: Object,
    variant: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show_popup: false
    }
  },
  computed: {
    imageSrc() {
      let image = this.image?.src || this.image?.url;
      if (image) {
        return image;
      }
      return image?.onerror;
    },
    style() {
      if (this.variant) {
        return "position-" + this.variant + "-" + this.$sizeType;
      }
      return "position-default";
    },
    imageStyle() {
      if (this.variant) {
        return "image-" + this.variant + "-" + this.$sizeType;
      }
      return "image-default";
    }
  },
  methods: {
    showPopup() {
      this.show_popup = !this.show_popup;
    },
    closePopup() {
      this.show_popup = false;
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.popup-container {
  position: relative;
}

.position-default {
  position: absolute;
  bottom: 15px;
  right: 20px;
  color: white;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  padding-left: 9px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 5px;
  height: 25px;
  width: 92px;
  min-width: 82px;
  min-height: 20px;
}  

.image-default{
  position: absolute;
  bottom: 3px;
  right: 17px;
  min-width: 50px;
  min-height: 20px;
  padding-bottom: 3px;
  padding-top: 3px;
}

.position-cookheader-desktop {
  position: absolute;
  left: -60px;
  top: 50px;
}

.position-cookheader-tablet {
  position: absolute;
  bottom: -20px;
  right: 20px;
}

.position-cookheader-mobile {
  position: absolute;
  bottom: -20px;
  right: 20px;
}
.caret-position-default {
  position: absolute;
    bottom: 7px;
    right: 66px;
  }
</style>
